export default class Article {
	constructor(article) {
		this.article = article != undefined && article != null ? article : null;
	}

	setArticle(article) {
		this.article = article;
	}

	price() {
		var price = parseFloat(this.article.price);

		if (this.hasDiscount()) {
			price = price - (price / 100) * parseFloat(this.article.discount);
		}

		return price.toFixed(2);
	}

	hasDiscount() {
		return this.article.discount ? true : false;
	}

	priceFormat(price) {
		return Intl.NumberFormat("ES-MX", {
			style: "currency",
			currency: "MXN",
		}).format(price);
	}

	mainImage() {
		try {
			return this.article.images[0];
		} catch (e) {
			return null;
		}
	}

	netContent() {
		if (this.article.unit_of_measurement) {
			if (this.article.contents < 1) {
				let unit_of_measurement = this.article.unit_of_measurement.name.toLowerCase();

				if (unit_of_measurement == "lt") {
					unit_of_measurement = "ml";
				} else {
					unit_of_measurement = "g";
				}

				return `${this.article.contents * 1000} ${unit_of_measurement}`;
			}

			let unit_of_measurement = this.article.unit_of_measurement.name.toLowerCase();

			return `${this.article.contents} ${unit_of_measurement}`;
		}

		return "";
	}

	weight() {
		if (this.article.weight < 1) {
			return `${this.article.weight * 1000} g`;
		}

		return `${this.article.weight} kg`;
	}
}
